// extracted by mini-css-extract-plugin
export default {"header":"Header_header__8rfy7","header-text":"Header_header-text__otlcw","header-logo":"Header_header-logo__+7Rh+","header-container":"Header_header-container__WOryi"};